import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c5dac5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OEditarPlanejamentoAtividade__titulo" }
const _hoisted_2 = { class: "OEditarPlanejamentoAtividade__Conteudo" }
const _hoisted_3 = {
  key: 0,
  class: "OEditarPlanejamentoAtividade__Etapas"
}
const _hoisted_4 = { class: "OEditarPlanejamentoAtividade__SomenteLeitura" }
const _hoisted_5 = { class: "OEditarPlanejamentoAtividade__Item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "OEditarPlanejamentoAtividade__Icone pi pi-list" }, null, -1))
const _hoisted_7 = { class: "OEditarPlanejamentoAtividade__Texto OEditarPlanejamentoAtividade__Texto--TipoDeAtividade" }
const _hoisted_8 = {
  key: 0,
  class: "OEditarPlanejamentoAtividade__Item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "OEditarPlanejamentoAtividade__Icone pi pi-map" }, null, -1))
const _hoisted_10 = { class: "OEditarPlanejamentoAtividade__Texto" }
const _hoisted_11 = { class: "OEditarPlanejamentoAtividade__Item OEditarPlanejamentoAtividade__Item--CodigoAtividadePlanejada" }
const _hoisted_12 = { class: "OEditarPlanejamentoAtividade__Texto" }
const _hoisted_13 = {
  key: 1,
  class: "OEditarPlanejamentoAtividade__SemAtributos"
}
const _hoisted_14 = { class: "OEditarPlanejamentoAtividade__Entradas" }
const _hoisted_15 = { class: "OEditarPlanejamentoAtividade__GrupoDeSeletor" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "OEditarPlanejamentoAtividade__Icone pi pi-users" }, null, -1))
const _hoisted_17 = { class: "OEditarPlanejamentoAtividade__GrupoDeSeletorTriplo OEditarPlanejamentoAtividade__Grupo--SemIcone" }
const _hoisted_18 = {
  key: 0,
  class: "OEditarPlanejamentoAtividade__GrupoDeSeletor"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "OEditarPlanejamentoAtividade__Icone pi pi-clock" }, null, -1))
const _hoisted_20 = {
  key: 1,
  class: "OEditarPlanejamentoAtividade__GrupoDeSeletor OEditarPlanejamentoAtividade__Grupo--SemIcone"
}
const _hoisted_21 = {
  key: 2,
  class: "OEditarPlanejamentoAtividade__ComAtributos"
}
const _hoisted_22 = { class: "OEditarPlanejamentoAtividade__Rodape" }

import { computed, onBeforeMount, onUnmounted, ref } from "vue"
  import { estados } from "@/types/api"
  import Dialog from "primevue/dialog"
  import AButton from "primevue/button"
  import {
    MCalendario,
    MDropdown,
    MEntradaNumerica,
    MMultiSelect,
    MModalSeletorRadio,
    AEtapas,
  } from "@/components/Gerais"
  import { MFormularioAtividadeComAtributos } from "@/components/Atributos"
  import { OSeletorSemanal } from "@/components/Calendario"
  import { AtributoBase } from "@/repositorios/atributos/atributos.modelos"
  import { Etapa } from "@/components/Gerais/AEtapas/AEtapas.modelos"
  import useVuelidate from "@vuelidate/core"
  import { Anulavel, EntidadeGenerica } from "@/types/gerais"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
  import CalendariosDasAtividadesRepositorio from "@/repositorios/calendarios/calendarios.repositorio"
  import AtividadesPlanejadasRepositorio from "@/repositorios/eventos/eventos.repositorio"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import {
    ListarProfissionais,
    ParamsProfissional,
  } from "@/repositorios/profissional/profissional.modelo"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import {
    CalendariosParams,
    ListarCalendariosDasAtividades,
    EditarCalendarioDaAtividade,
    CriarCalendarioDaAtividade,
  } from "@/repositorios/calendarios/calendarios.modelos"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import {
    EditarAtividadePlanejada,
    AtividadePlanejadaSimples,
    ParametrosAtividadePlanejada,
  } from "@/repositorios/eventos/eventos.modelo"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import {
    and,
    helpers,
    minLength,
    required,
    requiredIf,
  } from "@vuelidate/validators"
  import { useI18n } from "vue-i18n"
  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"

  interface Props {
    visibilidade: boolean
    profissionaisAlocados: Anulavel<EntidadeGenerica[]>
    nomeProjeto: Anulavel<string>
    nomeAtividade: string
    codigoAtividade: string
    idCalendario: Anulavel<string>
    idAtividadePlanejada: string
    duracaoEmMinutosDoEvento: number
    idEventoAtividadePlanejada: string
    dataHoraInicioEvento: Date
    dataHoraFimEvento: Date
    atributosEsperados?: AtributoBase[]
  }

  interface Emissores {
    (event: "update:visibilidade", visibilidade: boolean): void
    (event: "onRecarregarAtividades"): void
  }

  type ModoDeEdicao =
    | "editar-somente-esta-atividade"
    | "editar-esta-atividade-e-as-seguintes"
    | "editar-todas-as-atividades"

  interface OpcaoDeEdicao {
    nome: string;
    chave: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OEditarPlanejamentoAtividade',
  props: {
    visibilidade: { type: Boolean },
    profissionaisAlocados: null,
    nomeProjeto: null,
    nomeAtividade: null,
    codigoAtividade: null,
    idCalendario: null,
    idAtividadePlanejada: null,
    duracaoEmMinutosDoEvento: null,
    idEventoAtividadePlanejada: null,
    dataHoraInicioEvento: null,
    dataHoraFimEvento: null,
    atributosEsperados: null
  },
  emits: ["update:visibilidade", "onRecarregarAtividades"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:visibilidade", visibilidade: boolean): void
    (event: "onRecarregarAtividades"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    visibilidade: boolean
    profissionaisAlocados: Anulavel<EntidadeGenerica[]>
    nomeProjeto: Anulavel<string>
    nomeAtividade: string
    codigoAtividade: string
    idCalendario: Anulavel<string>
    idAtividadePlanejada: string
    duracaoEmMinutosDoEvento: number
    idEventoAtividadePlanejada: string
    dataHoraInicioEvento: Date
    dataHoraFimEvento: Date
    atributosEsperados?: AtributoBase[]
  }

  
  
  const {
    pegarDataDeHoje,
    verificarSeDataEhMenorOuIgualQue,
    converterParaTimeZoneLocal,
    pegarSomenteData,
    pegarSomenteAsHoras,
    obterTimeZoneLocal,
    aplicarTimeZoneNaDataHora,
    ehPrimeiroEventoDoCalendario,
    adicionarMinutosAUmaData,
    aplicarTimezoneEmHorasMinutos
  } = usarDataHora()

  const { t } = useI18n()

  const { colher } = usarManipuladorObjetos()
  const { leitor, resolverLeitor } = usarLeitorDeDados()
  const { escritor, resolver } = usarEscritorDeDados()
  const { onErro, onSucesso } = usarMensagemUsuario()

  const profissionalRepositorio = new ProfissionalRepositorio({
    utilizaCache: true,
  })

  const calendariosRepositorio = new CalendariosDasAtividadesRepositorio({
    utilizaCache: true,
  })

  const atividadesPlanejadasRepositorio = new AtividadesPlanejadasRepositorio()

  const lerProfissionais = leitor<ListarProfissionais, ParamsProfissional>(
    profissionalRepositorio.listarProfissionaisFrontend,
    {
      "por-pagina": 1000,
      "ordenar-por": "asc.nome",
    }
  )

  const escritorEditarAtividadePlanejada = escritor<
    { id: string },
    string,
    EditarAtividadePlanejada
  >(atividadesPlanejadasRepositorio.editarAtividadePlanejada, [])

  const escritorEditarCalendarioDaAtividade = escritor<
    { id: string },
    string,
    EditarCalendarioDaAtividade
  >(calendariosRepositorio.editarCalendariosDasAtividades, [])

  const escritorCriarCalendarioDaAtividade = escritor<
    { id: string },
    CriarCalendarioDaAtividade
  >(calendariosRepositorio.criarCalendarioDaAtividade, [])

  const lerCalendarios = leitor<
    ListarCalendariosDasAtividades,
    CalendariosParams
  >(calendariosRepositorio.listarCalendariosDaAtividade)

  const lerEventosPlanejados = leitor<AtividadePlanejadaSimples, ParametrosAtividadePlanejada>(
    atividadesPlanejadasRepositorio.listarAtividadesPlanejadas,
    {}
  )

  const profissionais = ref<EntidadeGenerica[]>([])
  const profissionaisSelecionados = ref<string[]>([])
  const opcoesRepeticao = [
    { id: "nao-repete", nome: t("naoRepete") },
    { id: "semanalmente", nome: t("repeteSemanalmente") },
  ]
  const opcaoRepeticaoSelecionado = ref<string>("nao-repete")
  const dataInicio = ref<Date>()
  const horaInicio = ref<Date>()
  const dataFimRepeticao = ref<Date>()
  const duracaoEmMinutos = ref<number>()
  const ultimoEventoCalendario = ref<AtividadePlanejadaSimples>()
  const calendarioDaAtividade = ref<ListarCalendariosDasAtividades>()
  const diasQueRepete = ref<number[]>([])
  const dataInicioEhMenorOuIgualHoje = ref(false)
  const mostrarSeletorDeOpcoes = ref(false)
  const estadoDeSalvamentoDeEdicoes = ref<number>(estados.INICIAL)
  const estadoDeCarregamentoProfissionais = ref<number>(estados.INICIAL)
  const estadoDeCarregamentoCalendario = ref<number>(estados.INICIAL)
  const caracteristicasStore = CaracteristicaStore()
  const etapaAtiva = ref<number>(0)

  const etapas = <Etapa[]>([
    { rotulo: t('etapaAtividade') },
    { rotulo: t('etapaAtributos') }
  ])

  const aoClicarNaEtapa = (indice: number) => {
    etapaAtiva.value = indice
  }

  const deveExibirEtapas = computed(() => {
    return temAtributos.value
  })

  const temAtributos = computed(() => {
    return props.atributosEsperados && props.atributosEsperados.length > 0
  })

  const regras = {
    profissionaisSelecionados: {},
    diasQueRepete: {
      required: helpers.withMessage(
        t("peloMenosUmDiaDeveSerSelecionado"),
        and(
          minLength(1),
          requiredIf(() => opcaoRepeticaoSelecionado.value === "semanalmente")
        )
      ),
    },
    opcaoRepeticaoSelecionado: {},
    duracaoEmMinutos: {},
    dataInicio: {
      required: helpers.withMessage(t("dataDeInicioObrigatoria"), required),
    },
    horaInicio: {
      required: helpers.withMessage(
        t("horarioDeInicioObrigatoria"),
        required
      ),
    },
    dataFimRepeticao: {},
  }

  const validador = useVuelidate(regras, {
    profissionaisSelecionados,
    diasQueRepete,
    opcaoRepeticaoSelecionado,
    duracaoEmMinutos,
    dataInicio,
    horaInicio,
    dataFimRepeticao,
  })

  const emissorVisibilidade = computed({
    get() {
      return props.visibilidade
    },
    set(visibilidade: boolean) {
      emitir("update:visibilidade", visibilidade)
    },
  })

  const minimoDataInicio = computed(() => {
    const dataFim = validador.value.dataFimRepeticao.$model
    return dataFim ?? pegarDataDeHoje()
  }) as unknown as Date

  const minimoDataFim = computed(() => {
    const dataInicioBaseMinima = validador.value.dataInicio.$model
    return dataInicioBaseMinima ?? undefined
  }) as unknown as Date | undefined

  const profissionaisEstaCarregando = computed(() => {
    return estadoDeCarregamentoProfissionais.value === estados.PEDENTE
  })

  const calendarioEstaCarregando = computed(() => {
    return estadoDeCarregamentoCalendario.value === estados.PEDENTE
  })

  const eventoPossuiCalendario = computed(() => {
    return (
      typeof props.idCalendario !== "undefined" && props.idCalendario !== null
    )
  })

  const estaCarregandoAlgo = computed(() => {
    return (
      estadoDeCarregamentoProfissionais.value === estados.PEDENTE ||
      estadoDeCarregamentoCalendario.value === estados.PEDENTE
    )
  })

  const estaSalvandoEdicoes = computed(() => {
    return estadoDeSalvamentoDeEdicoes.value === estados.PEDENTE
  })

  const buscarUltimoEventoDoCalendario = async (
    calendarioId: string
  ): Promise<void> => {
    ultimoEventoCalendario.value = undefined

    lerEventosPlanejados.sobrescreverParametros({
      "calendario_que_criou_id": `igual.${calendarioId}`,
      "ordenar-por": "desc.data_inicio",
      "por-pagina": 1000
    })

    await lerEventosPlanejados.executar()

    resolverLeitor<AtividadePlanejadaSimples>(lerEventosPlanejados.resultado, {
      sucesso: async (dados) => {
        ultimoEventoCalendario.value = dados[0]
      },
      erro: () => {
        onErro({
          resumo: t("ocorreuUmErro"),
          detalhes: t("naoFoiPossívelAcessarOsEventosDoCalendario"),
        })
      }
    })
  }

  const opcoesSeletorDeSalvamento = computed(() => {
    const editarSomenteEstaAtividade = {
      nome: t("editarSomenteEstaAtividade"),
      chave: "editar-somente-esta-atividade",
    }

    const editarEstaAtividadeEAsSeguintes = {
      nome: t("editarEstaAtividadeAsSeguintes"),
      chave: "editar-esta-atividade-e-as-seguintes",
    }

    const editarTodasAsAtividades = {
      nome: t("editarTodasAsAtividades"),
      chave: "editar-todas-as-atividades",
    }

    if (calendarioDaAtividade.value) {
      const dataHoje = pegarSomenteData(pegarDataDeHoje())
      const horarioAtual = pegarSomenteAsHoras(pegarDataDeHoje())

      const mapaDoCalendario = calendarioDaAtividade.value.mapaDoCalendario
      const dataInicioCalendario = calendarioDaAtividade.value.dataInicial
      const horaInicioCalendario = aplicarTimezoneEmHorasMinutos(calendarioDaAtividade.value.horarioDeInicio, -3)
      const dataFinalCalendario = calendarioDaAtividade.value.dataFinal

      const calendarioIniciaNoPassado = (dataInicioCalendario < dataHoje) ||
      (dataInicioCalendario === dataHoje && horaInicioCalendario < horarioAtual)

      const dataInicioEvento = pegarSomenteData(props.dataHoraInicioEvento)

      const eventoNoUltimoDiaDoCalendario = dataInicioEvento === ultimoEventoCalendario.value?.dataInicio
      const eventoAntesDoUltimoDiaDoCalendario = dataInicioEvento < dataFinalCalendario
      const eventoDepoisDoInicioDoCalendario = dataInicioEvento > dataInicioCalendario
      const eventoNoPrimeiroDiaDoCalendario = ehPrimeiroEventoDoCalendario(
        mapaDoCalendario,
        dataInicioCalendario,
        dataInicioEvento
      )

      const definirOpcoesParaCalendarioNoPassado = (): OpcaoDeEdicao[] => {
        if (eventoNoUltimoDiaDoCalendario) {
          return [editarSomenteEstaAtividade]
        }

        return [editarSomenteEstaAtividade, editarEstaAtividadeEAsSeguintes]
      }

      const definirOpcoesParaCalendarioNoFuturo = (): OpcaoDeEdicao[] => {
        if (eventoNoPrimeiroDiaDoCalendario || eventoNoUltimoDiaDoCalendario) {
          return [
            editarSomenteEstaAtividade,
            editarTodasAsAtividades,
          ]
        } else if (eventoDepoisDoInicioDoCalendario && eventoAntesDoUltimoDiaDoCalendario) {
          return [
            editarSomenteEstaAtividade,
            editarEstaAtividadeEAsSeguintes,
            editarTodasAsAtividades,
          ]
        }
        return [editarSomenteEstaAtividade]
      }

      if (calendarioIniciaNoPassado) {
        return definirOpcoesParaCalendarioNoPassado()
      } else {
        return definirOpcoesParaCalendarioNoFuturo()
      }
    }

    return [editarSomenteEstaAtividade]
  })

  const fecharModal = (): void => {
    emissorVisibilidade.value = false
    resetarFormulario()
  }

  const resetarFormulario = (): void => {
    validador.value.$reset()
    profissionaisSelecionados.value = []
    opcaoRepeticaoSelecionado.value = "nao-repete"
    dataInicio.value = undefined
    horaInicio.value = undefined
    dataFimRepeticao.value = undefined
    duracaoEmMinutos.value = undefined
    diasQueRepete.value = []
    dataInicioEhMenorOuIgualHoje.value = false
    mostrarSeletorDeOpcoes.value = false
    estadoDeSalvamentoDeEdicoes.value = estados.INICIAL
    estadoDeCarregamentoProfissionais.value = estados.INICIAL
    estadoDeCarregamentoCalendario.value = estados.INICIAL
    etapaAtiva.value = 0
  }

  const acaoBotaoSubmissor = (): void => {
    mostrarSeletorDeOpcoes.value = true
  }

  const definirDiasComAtividade = (listaDeIndices: number[]): void => {
    diasQueRepete.value = listaDeIndices
  }

  const atribuirProfissionaisAlocadosASelecionados = (): void => {
    const profissionaisAlocados = props.profissionaisAlocados
    if (!profissionaisAlocados) {
      return
    }
    profissionaisSelecionados.value = profissionaisAlocados.map(
      (profissional) => {
        return profissional.id
      }
    )
  }

  const formatarDiasComAtividadeParaAPI = (
    listaDeDias: number[]
  ): Record<number, boolean> => {
    return listaDeDias.reduce((acumulador, diaDeAtividade) => {
      acumulador[diaDeAtividade] = true
      return acumulador
    }, {})
  }

  const setarValoresDoEvento = () => {
    dataInicio.value = props.dataHoraInicioEvento
    horaInicio.value = props.dataHoraInicioEvento
    duracaoEmMinutos.value = props.duracaoEmMinutosDoEvento
  }

  const setarValoresDoCalendario = (
    calendario: ListarCalendariosDasAtividades
  ) => {
    const { dataInicial, dataFinal, mapaDoCalendario, horarioDeInicio } =
      calendario

    const dataInicialCalendarioFormatada = converterParaTimeZoneLocal(
      dataInicial,
      horarioDeInicio
    )
    const dataFinalCalendarioFormatada = converterParaTimeZoneLocal(
      dataFinal,
      horarioDeInicio
    )

    const converterDiasDaSemanaParaIndice = () => {
      const { diasComAtividade } = mapaDoCalendario
      const diasValidosComAtividade: number[] = []

      for (const dia in diasComAtividade) {
        if (diasComAtividade[dia]) {
          diasValidosComAtividade.push(Number(dia))
        }
      }
      const diaDaSemanaBase = new Date(dataInicialCalendarioFormatada).getDay()
      return diasValidosComAtividade.map((diaComBaseNoSelecionado) => {
        const indiceNoArrayDeDias =
          (diaComBaseNoSelecionado + diaDaSemanaBase) % 7
        return indiceNoArrayDeDias === 0 ? 7 : indiceNoArrayDeDias
      })
    }

    diasQueRepete.value = converterDiasDaSemanaParaIndice()
    dataInicioEhMenorOuIgualHoje.value =
      verificarSeDataEhMenorOuIgualQue(dataInicial)
    opcaoRepeticaoSelecionado.value = "semanalmente"
    dataFimRepeticao.value = dataFinalCalendarioFormatada
    dataInicio.value = dataInicialCalendarioFormatada
  }

  const lidarComSalvamentoDeEdicao = async (
    modoDeEdicao: string
  ): Promise<void> => {
    const tipoDeRequisicao: {
      [key in ModoDeEdicao]: () => Promise<void>
    } = {
      "editar-somente-esta-atividade": editarSomenteEstaAtividade,
      "editar-esta-atividade-e-as-seguintes": editarEstaAtividadeEAsSeguintes,
      "editar-todas-as-atividades": editarTodasAsAtividades,
    }

    estadoDeSalvamentoDeEdicoes.value = estados.PEDENTE
    try {
      await tipoDeRequisicao[modoDeEdicao]()

       // Delay para que dê tempo de pelo menos as atividades da semanas serem editadas
      setTimeout(() => {
        emitir("onRecarregarAtividades")
        fecharModal()
        estadoDeSalvamentoDeEdicoes.value = estados.SUCESSO
      }, 5000)

      onSucesso({
        resumo: t("edicoesSalvas"),
        detalhes: t("vaoAparecerNoCalendarioEmInstantas"),
      })
    } catch (e) {
      onErro({
        resumo: t("ocorreuUmErroAoSalvarAsEdicoes"),
        detalhes: t("tenteNovamenteMaisTarde"),
      })
      estadoDeSalvamentoDeEdicoes.value = estados.ERRO
    }
  }

  const editarSomenteEstaAtividade = async (): Promise<void> => {
    let dataHoraInicioPreenchido: Date

    if (eventoPossuiCalendario.value) {
      dataHoraInicioPreenchido = aplicarTimeZoneNaDataHora(
        pegarSomenteData(props.dataHoraInicioEvento),
        pegarSomenteAsHoras(horaInicio.value!),
        obterTimeZoneLocal()
      )
    } else {
      dataHoraInicioPreenchido = aplicarTimeZoneNaDataHora(
        pegarSomenteData(dataInicio.value!),
        pegarSomenteAsHoras(horaInicio.value!),
        obterTimeZoneLocal()
      )
    }

    const dataHoraFimAPartirDoInicio = adicionarMinutosAUmaData(
      dataHoraInicioPreenchido,
      duracaoEmMinutos.value!
    )

    const argumentos: EditarAtividadePlanejada = {
      profissionaisAlocadosId: profissionaisSelecionados.value,
      dataInicio: pegarSomenteData(dataHoraInicioPreenchido),
      horaInicio: pegarSomenteAsHoras(dataHoraInicioPreenchido),
      dataFim: pegarSomenteData(dataHoraFimAPartirDoInicio),
      horaFim: pegarSomenteAsHoras(dataHoraFimAPartirDoInicio),
      duracaoEmMinutos: duracaoEmMinutos.value!,
      timezoneInicio: obterTimeZoneLocal(),
      timezoneFim: obterTimeZoneLocal(),
    }

    escritorEditarAtividadePlanejada.mudarArgumentos([
      props.idEventoAtividadePlanejada,
      argumentos,
    ])
    await escritorEditarAtividadePlanejada.executar()

    resolver(escritorEditarAtividadePlanejada.resultado, {
      sucesso: () => {
        return
      },
      erro: () => {
        throw new Error(t("ocorreuUmErroAoSalvarAsEdicoes"))
      },
    })
  }

  const editarEstaAtividadeEAsSeguintes = async (): Promise<void> => {
    const alterarDataFinalCalendarioParaDiaAnterior =
      async (): Promise<void> => {
        const calendarioAtualDoEvento = calendarioDaAtividade.value

        if (!calendarioAtualDoEvento) {
          throw new Error("calendarioAtualDoEvento está não foi definido")
        }

        const dataAnteriorAoDiaDoEvento = new Date(
          new Date(props.dataHoraInicioEvento).setDate(props.dataHoraInicioEvento.getDate() - 1)
        )

        escritorEditarCalendarioDaAtividade.mudarArgumentos([
          props.idCalendario!,
          {
            idAtividadeDoProjeto: calendarioAtualDoEvento.idAtividadeDoProjeto,
            dataInicial: calendarioAtualDoEvento?.dataInicial as string,
            dataFinal: pegarSomenteData(dataAnteriorAoDiaDoEvento),
            numeroDeDias: 7,
            diasComAtividade: calendarioAtualDoEvento?.mapaDoCalendario.diasComAtividade as Record<number, boolean>,
            horarioDeInicio:  aplicarTimezoneEmHorasMinutos(
              calendarioAtualDoEvento?.horarioDeInicio,
              calendarioAtualDoEvento?.timezoneFim
            ) as string,
            prioridade: calendarioAtualDoEvento?.prioridade,
            duracaoEmMinutos: calendarioAtualDoEvento?.duracaoEmMinutos ?? props.duracaoEmMinutosDoEvento,
            timezoneInicio: calendarioAtualDoEvento?.timezoneInicio as number,
            timezoneFim: calendarioAtualDoEvento?.timezoneFim as number,
            idsProfissionaisAlocados: calendarioAtualDoEvento?.profissionaisAlocados.map((profissional) => profissional.id) as string[],
          },
        ])

        await escritorEditarCalendarioDaAtividade.executar()

        resolver(escritorEditarCalendarioDaAtividade.resultado, {
          sucesso: () => {
            return
          },
          erro: () => {
            throw new Error(
              t("ocorreuUmErroAoSalvarAsEdicoes")
            )
          },
        })
      }

    const criarNovoCalendarioComAlteracoes = async (): Promise<void> => {
      const totalDeDiasDaSemana = 7

      const voltarOsDiasParaIndices = (
        diasSelecionados: number[],
        dataBaseAntiga: Date
      ): number[] => {
        const diaDaSemanaBase = new Date(dataBaseAntiga).getDay()
        return diasSelecionados.map((diaComBaseNoSelecionado) => {
          const indiceNoArrayDeDias =
            (diaComBaseNoSelecionado + diaDaSemanaBase) % 7
          return indiceNoArrayDeDias === 0 ? 7 : indiceNoArrayDeDias
        })
      }

      const recalcularDiasQueRepeteParaNovaDataBase = (
        listaDeIndices: number[],
        novaDataBase: Date
      ): number[] => {
        const obterIndiceMapeado = (indiceParaMapear: number): number => {
          const indiceDoDiaBaseNaSemana = new Date(novaDataBase).getDay()
          const numeroDeDiasDaSemana = 7

          if (indiceParaMapear > indiceDoDiaBaseNaSemana) {
            return indiceParaMapear - indiceDoDiaBaseNaSemana
          } else {
            const numeroDeDiasParaRecuar =
              indiceDoDiaBaseNaSemana - indiceParaMapear
            return numeroDeDiasDaSemana - numeroDeDiasParaRecuar
          }
        }

        return [...listaDeIndices].map((diaSelecionado) =>
          obterIndiceMapeado(diaSelecionado)
        )
      }

      const indicesNaDataBaseAntiga = voltarOsDiasParaIndices(
        diasQueRepete.value,
        dataInicio.value!
      )

      const diasQueRepeteNaNovaDataBase =
        recalcularDiasQueRepeteParaNovaDataBase(
          indicesNaDataBaseAntiga,
          props.dataHoraInicioEvento
        )

      const novoCalendarioDaAtividade: CriarCalendarioDaAtividade = {
        idAtividadeDoProjeto: calendarioDaAtividade.value!.idAtividadeDoProjeto,
        dataInicial: pegarSomenteData(props.dataHoraInicioEvento),
        horarioDeInicio: pegarSomenteAsHoras(horaInicio.value as Date),
        dataFinal: pegarSomenteData(dataFimRepeticao.value as Date),
        numeroDeDias: totalDeDiasDaSemana,
        duracaoEmMinutos: duracaoEmMinutos.value,
        idsProfissionaisAlocados: profissionaisSelecionados.value,
        diasComAtividade: formatarDiasComAtividadeParaAPI(
          diasQueRepeteNaNovaDataBase
        ),
        timezoneInicio: obterTimeZoneLocal(),
        timezoneFim: obterTimeZoneLocal(),
      }

      escritorCriarCalendarioDaAtividade.mudarArgumentos([
        novoCalendarioDaAtividade,
      ])

      await escritorCriarCalendarioDaAtividade.executar()

      resolver(escritorCriarCalendarioDaAtividade.resultado, {
        sucesso: () => {
          return
        },
        erro: () => {
          throw new Error(t("ocorreuUmErroAoSalvarAsEdicoes"))
        },
      })
    }

    await alterarDataFinalCalendarioParaDiaAnterior()
    await criarNovoCalendarioComAlteracoes()
  }

  const editarTodasAsAtividades = async (): Promise<void> => {
    const totalDeDiasDaSemana = 7

    escritorEditarCalendarioDaAtividade.mudarArgumentos([
      props.idCalendario!,
      {
        idAtividadeDoProjeto: calendarioDaAtividade.value!.idAtividadeDoProjeto,
        dataInicial: pegarSomenteData(dataInicio.value as Date),
        horarioDeInicio: pegarSomenteAsHoras(horaInicio.value as Date),
        dataFinal: pegarSomenteData(dataFimRepeticao.value as Date),
        numeroDeDias: totalDeDiasDaSemana,
        duracaoEmMinutos: duracaoEmMinutos.value,
        idsProfissionaisAlocados: profissionaisSelecionados.value,
        diasComAtividade: formatarDiasComAtividadeParaAPI(diasQueRepete.value),
        timezoneInicio: obterTimeZoneLocal(),
        timezoneFim: obterTimeZoneLocal(),
      },
    ])

    await escritorEditarCalendarioDaAtividade.executar()

    resolver(escritorEditarCalendarioDaAtividade.resultado, {
      sucesso: () => {
        return
      },
      erro: () => {
        throw new Error(t("ocorreuUmErroAoSalvarAsEdicoes"))
      },
    })
  }

  const buscarListaDeProfissionais = async (): Promise<void> => {
    estadoDeCarregamentoProfissionais.value = estados.PEDENTE
    await lerProfissionais.executar()

    const lidarComSucessoDoLeitor = (
      resultado: ListarProfissionais[]
    ): void => {
      profissionais.value = colher<
        ListarProfissionais,
        { id: string; nome: string }
      >(resultado, ["id", "nome"])
      atribuirProfissionaisAlocadosASelecionados()
      estadoDeCarregamentoProfissionais.value = estados.SUCESSO
      Promise.resolve()
    }

    const lidarComErroDoLeitor = (): void => {
      estadoDeCarregamentoProfissionais.value = estados.ERRO
      throw new Error(t("ocorreuUmErroAoBuscarListaDeProfissionais"))
    }

    resolverLeitor(lerProfissionais.resultado, {
      sucesso: lidarComSucessoDoLeitor,
      erro: lidarComErroDoLeitor,
    })
  }

  const buscarDadosDoCalendario = async (): Promise<void> => {
    if (!eventoPossuiCalendario.value) {
      setarValoresDoEvento()
      Promise.resolve()
      return
    }
    estadoDeCarregamentoCalendario.value = estados.PEDENTE
    lerCalendarios.sobrescreverParametros({
      id: `igual.${props.idCalendario}`,
    })
    await lerCalendarios.executar()

    const lidarComSucessoDoLeitor = (
      resultado: ListarCalendariosDasAtividades[]
    ) => {
      estadoDeCarregamentoCalendario.value = estados.SUCESSO
      calendarioDaAtividade.value = resultado[0]
      setarValoresDoEvento()
      setarValoresDoCalendario(resultado[0])
      Promise.resolve()
    }

    const lidarComErroDoLeitor = (): void => {
      estadoDeCarregamentoCalendario.value = estados.ERRO
      throw new Error(t("ocorreuUmErroAoBuscarAsInformacoesDoCalendario"))
    }

    if (lerCalendarios.resultado.status === "sucesso") {
      lidarComSucessoDoLeitor(lerCalendarios.resultado.dados)
    } else if (lerCalendarios.resultado.status === "erro") {
      lidarComErroDoLeitor()
    } else if (lerCalendarios.resultado.status === "vazio") {
      estadoDeCarregamentoCalendario.value = estados.SUCESSO
    }
  }

  const carregarDadosComCalendario = async (calendarioId: string): Promise<void> => {
    try {
      await Promise.all([
        buscarListaDeProfissionais(),
        buscarUltimoEventoDoCalendario(calendarioId),
        buscarDadosDoCalendario(),
      ])
    } catch (e) {
      fecharModal()
      onErro({
        resumo: t("ocorreuUmErroAoCarregarOsDados"),
        detalhes: t("tenteNovamenteMaisTarde"),
      })
    }
  }

  const carregarDadosSemCalendario = async (): Promise<void> => {
    await buscarListaDeProfissionais()
    setarValoresDoEvento()
  }

  const lidarComCarregamentoDeDados = async (): Promise<void> => {
    const temCalendario = props.idCalendario

    if (temCalendario) {
      await carregarDadosComCalendario(props.idCalendario)
    } else {
      await carregarDadosSemCalendario()
    }
  }

  onBeforeMount(async () => {
    await lidarComCarregamentoDeDados()
  })
  onUnmounted(() => {
    caracteristicasStore.resetarCaracteristicas()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Dialog), {
      visible: _unref(emissorVisibilidade),
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_isRef(emissorVisibilidade) ? (emissorVisibilidade).value = $event : null)),
      class: "OEditarPlanejamentoAtividade",
      "data-testid": "OEditarPlanejamentoAtividade",
      draggable: false,
      modal: "",
      style: { 'max-width': '684px', height: 'auto', width: '100%' }
    }, {
      header: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('editarAtividade')), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_unref(AButton), {
            onClick: fecharModal,
            class: "OEditarPlanejamentoAtividade__BotaoCancelar",
            "data-testid": "OEditarPlanejamentoAtividade__BotaoCancelar",
            disabled: _unref(estaSalvandoEdicoes) || _unref(estaCarregandoAlgo),
            label: _unref(t)('cancelar')
          }, null, 8, ["disabled", "label"]),
          _createVNode(_unref(AButton), {
            onClick: acaoBotaoSubmissor,
            class: "OEditarPlanejamentoAtividade__Botao OEditarPlanejamentoAtividade__BotaoSubmissor",
            "data-testid": "OEditarPlanejamentoAtividade__BotaoSubmissor",
            disabled: 
            _unref(estaSalvandoEdicoes) || _unref(estaCarregandoAlgo) || _unref(validador).$invalid
          ,
            label: _unref(estaCarregandoAlgo) ? _unref(t)('carregandoDados') : _unref(t)('salvarEdicoes'),
            loading: _unref(estaSalvandoEdicoes) || _unref(estaCarregandoAlgo)
          }, null, 8, ["disabled", "label", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("main", _hoisted_2, [
          (_unref(deveExibirEtapas))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(AEtapas), {
                  clicavel: "",
                  largura: "50%",
                  etapas: _unref(etapas),
                  "indice-ativo": etapaAtiva.value,
                  onEtapaClicada: aoClicarNaEtapa
                }, null, 8, ["etapas", "indice-ativo"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("h2", _hoisted_7, _toDisplayString(__props.nomeAtividade), 1)
            ]),
            (__props.nomeProjeto)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(__props.nomeProjeto), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h2", _hoisted_12, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('codDaAtividadePlanejada')), 1),
                _createTextVNode(" " + _toDisplayString(__props.codigoAtividade), 1)
              ])
            ])
          ]),
          (etapaAtiva.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_unref(MMultiSelect), {
                      modelValue: _unref(validador).profissionaisSelecionados.$model,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(validador).profissionaisSelecionados.$model) = $event)),
                      carregando: _unref(profissionaisEstaCarregando),
                      class: "OEditarPlanejamentoAtividade__SeletorProfissionais",
                      "data-testid": "OEditarPlanejamentoAtividade__SeletorProfissionais",
                      "exibicao-de-opcoes": "comma",
                      "maximo-de-legendas-selecionadas": 3,
                      "mensagem-de-erro": 
              _unref(validador).profissionaisSelecionados.$errors[0]?.$message
            ,
                      nome: "profissionais alocados",
                      "option-label": "nome",
                      "option-value": "id",
                      options: profissionais.value,
                      placeholder: _unref(t)('profissionaisAlocados'),
                      width: "480px"
                    }, null, 8, ["modelValue", "carregando", "mensagem-de-erro", "options", "placeholder"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(MCalendario), {
                      modelValue: _unref(validador).dataInicio.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(validador).dataInicio.$model) = $event)),
                      class: "OEditarPlanejamentoAtividade__DataInicio",
                      desabilitado: 
              dataInicioEhMenorOuIgualHoje.value || _unref(calendarioEstaCarregando)
            ,
                      "mensagem-de-erro": _unref(validador).dataInicio.$errors[0]?.$message,
                      "min-data": _unref(minimoDataInicio),
                      obrigatorio: "",
                      rotulo: _unref(t)('dataDeInicio')
                    }, null, 8, ["modelValue", "desabilitado", "mensagem-de-erro", "min-data", "rotulo"]),
                    _createVNode(_unref(MCalendario), {
                      modelValue: _unref(validador).horaInicio.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(validador).horaInicio.$model) = $event)),
                      class: "OEditarPlanejamentoAtividade__HoraInicio",
                      desabilitado: _unref(calendarioEstaCarregando),
                      "esconder-picker": true,
                      "formato-hora": "24",
                      icon: "pi pi-clock",
                      "mensagem-de-erro": _unref(validador).horaInicio.$errors[0]?.$message,
                      "mostrar-horas": false,
                      obrigatorio: "",
                      rotulo: _unref(t)('horarioDeInicio'),
                      "somente-hora": ""
                    }, null, 8, ["modelValue", "desabilitado", "mensagem-de-erro", "rotulo"]),
                    _createVNode(_unref(MEntradaNumerica), {
                      modelValue: duracaoEmMinutos.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((duracaoEmMinutos).value = $event)),
                      class: "OEditarPlanejamentoAtividade__Duracao",
                      desativado: _unref(calendarioEstaCarregando),
                      "mensagem-de-erro": _unref(validador).duracaoEmMinutos.$errors[0]?.$message,
                      min: 0,
                      nome: "duracaoEmMinutos",
                      obrigatorio: "",
                      rotulo: _unref(t)('duracaoMinutos')
                    }, null, 8, ["modelValue", "desativado", "mensagem-de-erro", "rotulo"])
                  ]),
                  (_unref(eventoPossuiCalendario))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_unref(MDropdown), {
                          modelValue: _unref(validador).opcaoRepeticaoSelecionado.$model,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(validador).opcaoRepeticaoSelecionado.$model) = $event)),
                          class: "OCriarEventoPlanejado__SeletorRepeticao",
                          desativado: _unref(calendarioEstaCarregando),
                          filtro: false,
                          "mensagem-de-erro": 
              _unref(validador).opcaoRepeticaoSelecionado.$errors[0]?.$message
            ,
                          nome: "repetição",
                          "option-label": "nome",
                          "option-value": "id",
                          options: opcoesRepeticao,
                          placeholder: _unref(t)('repeticao'),
                          "usar-carregamento-sob-demanda": "",
                          width: "277px"
                        }, null, 8, ["modelValue", "desativado", "mensagem-de-erro", "placeholder"]),
                        _createElementVNode("p", null, _toDisplayString(_unref(t)("ate")), 1),
                        _createVNode(_unref(MCalendario), {
                          modelValue: _unref(validador).dataFimRepeticao.$model,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(validador).dataFimRepeticao.$model) = $event)),
                          class: "OEditarPlanejamentoAtividade__FimDaRepeticao",
                          desabilitado: 
              _unref(calendarioEstaCarregando) ||
                opcaoRepeticaoSelecionado.value === 'nao-repete'
            ,
                          "mensagem-de-erro": _unref(validador).dataFimRepeticao.$errors[0]?.$message,
                          "min-data": _unref(minimoDataFim),
                          obrigatorio: "",
                          rotulo: _unref(t)('fimDaRepeticao')
                        }, null, 8, ["modelValue", "desabilitado", "mensagem-de-erro", "min-data", "rotulo"])
                      ]))
                    : _createCommentVNode("", true),
                  (
            opcaoRepeticaoSelecionado.value === 'semanalmente' &&
              _unref(eventoPossuiCalendario)
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_unref(OSeletorSemanal), {
                          onOnMapearDiasSelecionados: definirDiasComAtividade,
                          "data-base": dataInicio.value!,
                          "mensagem-de-erro": _unref(validador).diasQueRepete.$errors[0]?.$message,
                          rotulo: _unref(t)('repetirNosDias'),
                          "valor-inicial": diasQueRepete.value
                        }, null, 8, ["data-base", "mensagem-de-erro", "rotulo", "valor-inicial"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (etapaAtiva.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_unref(MFormularioAtividadeComAtributos), {
                  "atributos-esperados": __props.atributosEsperados,
                  "desabilitar-campos": true
                }, null, 8, ["atributos-esperados"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(MModalSeletorRadio), {
      onAoAlterarVisibilidade: _cache[7] || (_cache[7] = ($event: any) => (mostrarSeletorDeOpcoes.value = $event)),
      onAoClicarEmSubmeter: lidarComSalvamentoDeEdicao,
      "botoes-radio": _unref(opcoesSeletorDeSalvamento),
      "esta-carregando": _unref(estaSalvandoEdicoes),
      "tipo-de-acao": "salvar",
      "titulo-cabecalho": _unref(t)('salvarEdicoesNaAtividadePlanejada'),
      visibilidade: mostrarSeletorDeOpcoes.value
    }, null, 8, ["botoes-radio", "esta-carregando", "titulo-cabecalho", "visibilidade"])
  ], 64))
}
}

})